import { useEffect, useState } from 'react';
import QRCode from 'qrcode';

/** QR-kod som data-URL, ritad lokalt (ingen extern QR-tjänst får se adressen). Tom text ger tom sträng. */
export function useQrDataUrl(text: string, size = 400): string {
  const [src, setSrc] = useState('');
  useEffect(() => {
    if (!text) { setSrc(''); return; }
    let alive = true;
    QRCode.toDataURL(text, { width: size, margin: 1, errorCorrectionLevel: 'H' })
      .then(u => { if (alive) setSrc(u); })
      .catch(() => { if (alive) setSrc(''); });
    return () => { alive = false; };
  }, [text, size]);
  return src;
}
